import { render, staticRenderFns } from "./ReturnDetails.vue?vue&type=template&id=959a4b2a&scoped=true&"
import script from "./ReturnDetails.vue?vue&type=script&lang=js&"
export * from "./ReturnDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959a4b2a",
  null
  
)

export default component.exports